import React from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer'
import ScaleBarPulse from './ScaleBarPulse'
import TableGridPulse from './TableGridPulse'

const styles = StyleSheet.create({
  tableHeaderTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableHeaderTitleText1: {
    fontFamily: 'Inter',
    fontSize: 15,
    fontWeight: 500,
    marginRight: 5,
    color: '#fff',
  },
  tableHeaderTitleText2: {
    fontFamily: 'Inter',
    fontSize: 12,
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    borderBottom: '1 solid rgb(226 232 240)',
  },
  tableFirstCol: {
    width: '60%',
    backgroundColor: '#ffffff',
  },
  tableFirstColAnswer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  tableFirstColAnswerText: {
    display: 'flex',
    flexDirection: 'row',
    width: '80%',
    paddingRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
  },
  tableFirstColAnswerPoints: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '10%',
    height: '100%',
    textAlign: 'right',
    paddingLeft: 5,
    paddingRight: 5,
  },
  tableLastCol: {
    width: '40%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgb(226 232 240)',
    borderBottom: '1 solid #fff',
    paddingRight: 7,
    opacity: 0.7,
  },
  tableLastColRows: {
    width: '100%',
    flexDirection: 'row',
    height: 15,
  },
  scaleBarContainer: {
    position: 'relative',
    zIndex: 50,
    display: 'flex',
    flexDirection: 'row',
  },
  gridContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '5.5%',
    top: -1,
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1 solid rgb(226 232 240)',
  },
  overviewText: {
    fontFamily: 'Inter',
    fontSize: 10,
    fontWeight: 500,
    paddingTop: 3,
    paddingBottom: 3,
    marginTop: 4,
    marginBottom: 4,
  }
});

const OverviewTableHealthQuinary = ({ coverData, categoriesData, uiData }) => {

  const roundToTwoDecimals = (num) => {
    if (isNaN(num) || num === null) {
      return "0.0";
    }
    const rounded = Math.round(num * 100) / 100;
    return rounded % 1 === 0 ? `${rounded}.0` : rounded.toFixed(1);
  };

  const calculateXPositionCategory = (point) => {
        return point !== undefined ? ((point - 1) / 4) * 100 : 0;
    };

  return (
    <>
      <View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            paddingLeft: '5%',
            paddingRight: '5%',
            backgroundColor: roundToTwoDecimals(coverData.avgPoint) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.avgPoint) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.avgPoint) <= 4 ? "#7bb662" : "#639754")),
          }}
        >
          <View style={styles.tableHeaderTitle}>
            <Text style={styles.tableHeaderTitleText1}>{uiData.features}</Text>
          </View>

          <View
            style={{
              color: '#ffffff',
              fontFamily: 'Inter',
              fontSize: 18,
              fontWeight: 700,
              padding: 5,
            }}
          >
            <Text>{roundToTwoDecimals(coverData.avgPoint)}</Text>
          </View>

        </View>
      </View>

      <View style={{ paddingRight: '5%', paddingLeft: '5%' }}>

        <View className='bg-white shadow-md p-8 rounded-lg flex flex-row justify-between'
          style={{
            backgroundColor: '#f9fafe',
            border: '1 solid rgb(226 232 240)',
            borderRadius: 5,
            padding: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 50,
          }}
        >

          <View style={{ width: '40%' }}>
            <Text style={styles.overviewText}>{uiData.date}</Text>
            <Text style={styles.overviewText}>{uiData.minimum}</Text>
            <Text style={styles.overviewText}>{uiData.maximum}</Text>
            <Text style={styles.overviewText}>{uiData.difference}</Text>
            <Text style={styles.overviewText}>{uiData.average}</Text>
          </View>

          <View style={{ width: '60%' }}>
            <View>

              <View>
                <View>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 600,
                      paddingTop: 7,
                      paddingBottom: 8,
                    }}
                  >
                    {coverData.timestamp}
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'center',
                    marginTop: 3,
                    marginBottom: 4,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      paddingTop: 3,
                      paddingBottom: 3,
                      paddingLeft: 5,
                      paddingRight: 5,
                      textAlign: 'center',
                      borderRadius: 3,
                      marginRight: 8,
                      color: '#fff',
                      width: 30,
                      backgroundColor: roundToTwoDecimals(coverData.minimum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.minimum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.minimum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {roundToTwoDecimals(coverData.minimum.points)}
                  </Text>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      color: roundToTwoDecimals(coverData.minimum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.minimum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.minimum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {coverData.minimum.category}
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'center',
                    marginTop: 3,
                    marginBottom: 4,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      textAlign: 'center',
                      paddingTop: 3,
                      paddingBottom: 3,
                      paddingLeft: 5,
                      paddingRight: 5,
                      borderRadius: 3,
                      marginRight: 8,
                      color: '#fff',
                      width: 30,
                      marginTop: 1,
                      backgroundColor: roundToTwoDecimals(coverData.maximum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.maximum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.maximum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {roundToTwoDecimals(coverData.maximum.points)}
                  </Text>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      color: roundToTwoDecimals(coverData.maximum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.maximum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.maximum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {coverData.maximum.category}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      display: 'inline',
                      textAlign: 'center',
                      width: 30,
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingTop: 3,
                      paddingBottom: 3,
                      marginTop: 4,
                      marginBottom: 4,
                    }}
                  >
                    {roundToTwoDecimals(coverData.diffMaxMin)}
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'center',
                  }}
                >
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      paddingTop: 3,
                      paddingBottom: 3,
                      paddingLeft: 5,
                      paddingRight: 5,
                      borderRadius: 3,
                      width: 30,
                      color: '#fff',
                      marginTop: 4,
                      textAlign: 'center',
                      backgroundColor: roundToTwoDecimals(coverData.avgPoint) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.avgPoint) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.avgPoint) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {roundToTwoDecimals(coverData.avgPoint)}
                  </Text>
                </View>
              </View>

            </View>
          </View>
        </View>
      </View>

      <View
        style={{
          position: 'relative',
          paddingLeft: '5%',
          paddingRight: '5%',
          marginTop: 50,
          width: '100%',
        }}
      >
        <View style={styles.gridContainer} zIndex={9999}>
          <View style={{ width: '60%' }}></View>
          <View style={{ width: '40%' }}>
            <TableGridPulse />
            <View
              style={{
                position: 'absolute',
                top: 0,
                bottom: 25,
                left: `${calculateXPositionCategory(coverData.avgPoint) - 0.5}%`,
                borderLeftWidth: 1,
                borderLeftColor: '#3395E0',
                borderStyle: 'dashed',
                zIndex: 9999,
              }}
            ></View>
          </View>
        </View>
        {categoriesData.map(entry => {

          const averagePoints = roundToTwoDecimals(coverData.avgPoint);
          const roundedPoints = roundToTwoDecimals(entry.points);
          const xPos = ((roundedPoints - 1) / 4) * 100;

          const getBackgroundColor = (roundedPoints, averagePoints) => {
            if (roundedPoints < averagePoints - 1) {
              return 'rgb(220, 38, 38)';
            } else if (roundedPoints >= averagePoints) {
              return 'rgb(77, 124, 15)';
            } else {
              return '#eac714';
            }
          };

          return (
            <View key={entry}>
              <View style={styles.tableContainer}>
                <View style={styles.tableFirstCol}>
                  <View style={styles.tableFirstColAnswer}>
                    <View style={styles.tableFirstColAnswerText}>
                      <Text
                        style={{
                          fontFamily: 'Inter',
                          fontSize: 10,
                          fontWeight: 500,
                          lineHeight: 1.2,
                        }}
                      >
                        {entry.name}
                      </Text>
                    </View>
                    <View style={styles.tableFirstColAnswerPoints}>
                      <Text
                        style={{
                          fontFamily: 'Inter',
                          fontSize: 10,
                          fontWeight: 700,
                        }}
                      >
                        {roundToTwoDecimals(entry.points)}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={styles.tableLastCol}>
                  <View style={styles.tableLastColRows}>
                    <View
                      style={{
                        height: 10,
                        width: 10,
                        backgroundColor: getBackgroundColor(roundedPoints, averagePoints),
                        borderRadius: '50%',
                        position: 'absolute',
                        left: `${xPos - 0.5}%`,
                        top: 2,
                      }}
                    >
                    </View>
                  </View>
                </View>
              </View>
            </View>
          );
        }
        )}
        <View style={styles.scaleBarContainer}>
          <View style={{ width: '60%' }}></View>
          <View style={{ width: '40%', marginBottom: 10 }}>
            <ScaleBarPulse />
          </View>
        </View>
      </View>

    </>
  )
}

export default OverviewTableHealthQuinary